import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { destinationAnimation, destinationImageAnimation } from './destinationAnimations';
import { Component, DestroyRef, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ArticleCardComponent } from '../shared/components/article-card/article-card.component';
import { DeviceService } from '../shared/services/device.service';
import {
  Article,
  ArticleService,
  Destination,
  DestinationService,
} from '../admin/shared/public-api';
import { MetaService } from '../shared/services/meta.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-destinations',
  templateUrl: './destinations.component.html',
  styleUrls: ['./destinations.component.scss'],
  animations: [destinationAnimation, destinationImageAnimation],
  imports: [CommonModule, RouterModule, ArticleCardComponent, NgOptimizedImage],
})
export class DestinationsComponent implements OnInit {
  private readonly destinationService = inject(DestinationService);
  private readonly articleService = inject(ArticleService);
  protected readonly deviceService = inject(DeviceService);
  private readonly metaTagService = inject(MetaService);

  destinations: Destination[];
  hoverDestinations: { [id: string]: boolean } = {};
  lastArticles: Observable<Article[]>;

  continents = [`Afrique`, `Amérique`, `Asie`, `Europe`, `Océanie`];
  continentDestinations: { [continent: string]: Destination[] } = {};

  constructor(route: ActivatedRoute, titleService: Title) {
    if (route.snapshot.data && route.snapshot.data['name']) {
      titleService.setTitle(route.snapshot.data['title']);
      const baseUrl = environment.baseUrl;
      const description = `Tous les pays que nous avons exploré sur une seule page!`;

      this.metaTagService.updateMetaTags(
        description,
        route.snapshot.data['title'],
        baseUrl + 'destinations',
        'website',
        `${baseUrl}/destinations/destinations.jpg`,
        1920,
        1080,
        'image/jpeg'
      );
    }
  }

  ngOnInit(): void {
    this.continents.forEach((c) => {
      this.continentDestinations[c] = [];
    });

    this.destinationService.getDestinations().subscribe((destinations) => {
      this.destinations = destinations.sort((a, b) => a.country.localeCompare(b.country));
      this.destinations.forEach((d) => {
        this.hoverDestinations[d.id] = false;
        this.continentDestinations[d.continent].push(d);
      });
    });

    this.lastArticles = this.articleService.getLastArticles(3);
  }

  navigateToDestination(country: string): void {
    window.location.href = `/destination/${country}`;
  }

  hoverDestination(destinationId: string, state: boolean): void {
    if (this.hoverDestinations[destinationId] != null) {
      this.hoverDestinations[destinationId] = state;
    }
  }
}
